import { IReviewForm } from "../../../components/Inputs/SelectForm";

import { ReviewQuestion } from "../../../pages/Administration/Reviews/EditForm/utils";

import request from "../base-request";

// forms are grouped by name
export interface IForm {
	forms: string[];
	name: string;
}

export interface IReviewFormData {
	results: IReviewForm[];
	errors: string[];
	warnings: string[];
}

export const getReviewForms = async (
	searchTerm?: string,
	includeDeleted: boolean = false,
	includeUsed: boolean = false
) => {
	let url = `/api/v1.0/review-form-picker/?include_deleted=${includeDeleted ? "true" : "false"}&include_used=${includeUsed ? "true" : "false"}`;
	if (searchTerm) {
		url += `&name=${searchTerm}`;
	}
	const [reviewFormData] = await request<IReviewFormData>(url);

	return reviewFormData;
};

export const getFormPreview = async (questions: ReviewQuestion[], name?: string) => {
	const [preview] = await request<{ errors?: string[]; html: string }>(`/v2/edit-review-form/preview`, {
		method: "POST",
		body: JSON.stringify({ questions, name }),
	});

	return preview;
};

export const getFormPreviewPDF = async (questions: ReviewQuestion[], name?: string) => {
	const [preview] = await request<{ errors?: string[]; url?: string }>(`/ajax/preview-form.pdf`, {
		method: "POST",
		body: JSON.stringify({ questions, name }),
	});

	//download file from url in response
	if (preview?.url) {
		const a = document.createElement("a");
		a.href = preview.url;
		a.download = "form.pdf";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	return preview;
};
